/**
 * DSL_FullScreenWindow
 * Full screen overlay window with semi-transparent background
 * Renders below HUD elements (z-index < 99999)
 */

import { memo, useCallback } from 'react'

const DSL_FullScreenWindow = memo(function DSL_FullScreenWindow({ onClose, children, isClosing }) {
  // Prevent scroll propagation to canvas/body
  const handleContainerTouchMove = useCallback((e) => {
    e.stopPropagation()
  }, [])
  
  const handleBackdropClick = useCallback((e) => {
    // Close if clicking the backdrop (outside content)
    if (e.target.classList.contains('dsl-fullscreen-window-container')) {
      onClose()
    }
  }, [onClose])
  
  return (
    <div 
      className={`dsl-fullscreen-window-container ${isClosing ? 'closing' : ''}`}
      onTouchMove={handleContainerTouchMove}
      onClick={handleBackdropClick}
    >
      <div className="dsl-fullscreen-window-content">
        <button className="dsl-fullscreen-window-close" onClick={onClose}>
          ×
        </button>
        
        {children}
      </div>
    </div>
  )
})

export default DSL_FullScreenWindow
